import api from './axiosConfig';

/**
 * Ask a question to the AI assistant about inventory
 * @param {Object} params - The parameters for the question
 * @param {string} params.question - The question to ask
 * @returns {Promise<Object>} - The AI assistant's response
 */
export const askInventoryQuestion = async ({
  question
}) => {
  try {
    const response = await api.post("/api/ai/ask", {
      question
    });
    return response.data;
  } catch (error) {
    console.error("Error asking inventory question:", error);
    throw error;
  }
};
